import { dsComponentRegistry } from "../registry"

/**
 * Returns a React component for a given design system container.
 *
 * Looks up the container's dsComponentType in the registry, maps its children and props,
 * and returns the corresponding React element.
 *
 * @param {Object} container - The container object, expected to have dsComponentType, :itemsOrder, and :items.
 * @return {React.ReactElement|null} The mapped React component, or null if not found or not mappable.
 */
export function getDSComponentForContainer(container) {
  if (!container?.dsComponentType) return null
  const mapping = dsComponentRegistry[container.dsComponentType]
  if (!mapping) return null

  const { component: DSComponent, mapper } = mapping

  // Return null if mapper is missing or not a function
  if (typeof mapper !== "function") return null

  const children =
    container[":itemsOrder"]
      ?.map(key => container[":items"][key])
      .filter(Boolean) || []
  const props = mapper(container, children)

  return <DSComponent {...props} />
}
